<div class="layout-wrapper" [ngClass]="containerClass">
    <app-topbar *ngIf="!isRestrictedMode"></app-topbar>
    <div class="layout-sidebar" *ngIf="!isRestrictedMode"><app-sidebar></app-sidebar></div>
    <!-- Edge of the inset panel that holds the header and the page (desktop, see _shell.scss). -->
    <div class="layout-inset-frame" *ngIf="!isRestrictedMode" aria-hidden="true"></div>
    <div class="layout-main-container">
        <div class="layout-main">
            <router-outlet></router-outlet>
        </div>
    </div>
    <div class="layout-mask"></div>
    <app-command-palette *ngIf="!isRestrictedMode"></app-command-palette>
</div>